// extracted by mini-css-extract-plugin
module.exports = {"Reviews-container":"ReviewsComponent_Reviews-container__3U6w-","Review-container":"ReviewsComponent_Review-container__yzYGD"};